import React from 'react';
import PageHero from '../components/PageHero';
import CTABanner from '../components/CTABanner';

const team = [
  { name:'Arjun Nair', role:'CEO & Founder', exp:'12+ yrs', img:'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&auto=format&fit=crop&q=70' },
  { name:'Deepa Krishnan', role:'Chief Technology Officer', exp:'10+ yrs', img:'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&auto=format&fit=crop&q=70' },
  { name:'Vikram Singh', role:'Mobile Lead', exp:'8+ yrs', img:'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&auto=format&fit=crop&q=70' },
  { name:'Meena Rajan', role:'Security Lead', exp:'9+ yrs', img:'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&auto=format&fit=crop&q=70' },
];

const milestones = [
  { year:'2016', title:'Studio Founded', desc:'Started as a 5-member MERN stack agency in Chennai, India.' },
  { year:'2018', title:'Java & Enterprise', desc:'Expanded into full stack Java and enterprise software. First Fortune 500 client.' },
  { year:'2020', title:'Flutter Mobile', desc:'Launched mobile division with Flutter. 20+ apps delivered in year one.' },
  { year:'2022', title:'Cyber Security', desc:'Added dedicated security practice with certified ethical hackers and SOC analysts.' },
  { year:'2023', title:'Digital Marketing', desc:'Formed full-service growth marketing team for 360° digital solutions.' },
  { year:'2025', title:'250+ Projects', desc:'Crossed milestone of 250 successful deliveries across 20+ countries.' },
];

const values = [
  { title:'Excellence', desc:'We settle for nothing less than the best in code quality, design, and delivery.' },
  { title:'Partnership', desc:'Your success is our success. We invest in understanding your business deeply.' },
  { title:'Transparency', desc:'Daily updates, open communication, and no hidden fees — ever.' },
  { title:'Innovation', desc:'We stay ahead of technology to give you a competitive edge.' },
];

const About = () => (
  <main>
    <PageHero title="About" highlight="Cegon Soft Tech" subtitle="A boutique technology studio founded on the belief that great software is a form of craft — precise, intentional, and built to endure." breadcrumb="About" />

    {/* Mission */}
    <section className="section-pad" style={{ background:'var(--bg)' }}>
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-5">
            <div style={{ position:'relative' }}>
              <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&auto=format&fit=crop&q=70"
                alt="Studio" style={{ width:'100%', height:520, objectFit:'cover', filter:'brightness(0.75) saturate(0.7)', display:'block' }} />
              <div style={{ position:'absolute', bottom:24, left:24, right:24, background:'rgba(28,21,16,0.85)', backdropFilter:'blur(10px)', border:'1px solid var(--border)', padding:'20px 24px' }}>
                <div style={{ display:'flex', gap:40 }}>
                  {[['8+','Years'],['40+','Team'],['20+','Countries']].map(([n,l]) => (
                    <div key={l}><div className="stat-num" style={{ fontSize:'2rem' }}>{n}</div><div className="stat-label">{l}</div></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <span className="section-label">Our Story</span>
            <h2 className="section-title mb-4">Building the <em>Future,</em><br/>One Line at a Time</h2>
            <p style={{ color:'var(--muted)', lineHeight:1.9, fontSize:'0.9rem', fontWeight:300, marginBottom:'1.5rem' }}>
              Founded in 2016 in Chennai, Cegon Soft Tech began with a simple mission — to help businesses harness technology for real, measurable growth. What started as a small MERN stack agency has evolved into a full-service digital technology studio.
            </p>
            <p style={{ color:'var(--muted)', lineHeight:1.9, fontSize:'0.9rem', fontWeight:300, marginBottom:'2.5rem' }}>
              Today, we are 40+ strong — developers, designers, marketers, and security experts united by a passion for craft. Our clients range from innovative startups to large enterprises across India, USA, UK, Australia and the Middle East.
            </p>

            <div className="row g-3">
              {[['🎯','Mission','Deliver transformative digital products that create lasting business value.'],
                ['👁️','Vision','Be the most trusted technology partner for businesses worldwide.']].map(([ic,h,t]) => (
                  <div key={h} className="col-sm-6">
                    <div style={{ borderTop:'1px solid var(--border)', paddingTop:20 }}>
                      <div style={{ fontSize:'1.3rem', marginBottom:10 }}>{ic}</div>
                      <div style={{ fontFamily:'var(--font-disp)', fontSize:'1.1rem', marginBottom:8, color:'var(--cream2)' }}>{h}</div>
                      <div style={{ color:'var(--muted)', fontSize:'0.82rem', lineHeight:1.75, fontWeight:300 }}>{t}</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Values */}
    <section className="section-pad" style={{ background:'var(--bg2)' }}>
      <div className="container">
        <span className="section-label">Core Values</span>
        <div className="row g-0 mt-4" style={{ border:'1px solid var(--border)' }}>
          {values.map((v,i) => (
            <div key={i} className="col-md-6 col-lg-3" style={{ padding:'40px 32px', borderRight:i<3?'1px solid var(--border)':'none', borderBottom:i<2?'1px solid var(--border)':'none' }}>
              <div style={{ fontFamily:'var(--font-disp)', fontSize:'1.8rem', fontWeight:400, color:'var(--tan)', marginBottom:14 }}>0{i+1}</div>
              <h5 style={{ fontFamily:'var(--font-disp)', fontSize:'1.2rem', fontWeight:400, color:'var(--cream2)', marginBottom:12 }}>{v.title}</h5>
              <p style={{ color:'var(--muted)', fontSize:'0.85rem', lineHeight:1.8, margin:0, fontWeight:300 }}>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Timeline */}
    <section className="section-pad" style={{ background:'var(--bg)' }}>
      <div className="container">
        <div className="row align-items-end mb-5">
          <div className="col-lg-5">
            <span className="section-label">Our Journey</span>
            <h2 className="section-title">Milestones of<br/><em>Growth</em></h2>
          </div>
        </div>
        <div className="row g-0" style={{ border:'1px solid var(--border)' }}>
          {milestones.map((m,i) => (
            <div key={i} className="col-md-6 col-lg-4" style={{ padding:'32px 28px', borderRight:i%3===2?'none':'1px solid var(--border)', borderBottom:i<3?'1px solid var(--border)':'none' }}>
              <div style={{ fontFamily:'var(--font-disp)', fontSize:'2.5rem', fontWeight:300, color:'var(--tan2)', lineHeight:1, marginBottom:14 }}>{m.year}</div>
              <h5 style={{ fontFamily:'var(--font-disp)', fontSize:'1.15rem', fontWeight:400, color:'var(--cream2)', marginBottom:10 }}>{m.title}</h5>
              <p style={{ color:'var(--muted)', fontSize:'0.84rem', lineHeight:1.8, margin:0, fontWeight:300 }}>{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Team */}
    <section className="section-pad" style={{ background:'var(--bg2)' }}>
      <div className="container">
        <div className="row align-items-end mb-5">
          <div className="col-lg-5">
            <span className="section-label">The Team</span>
            <h2 className="section-title">People Behind<br/><em>Cegon Soft Tech</em></h2>
          </div>
          <div className="col-lg-7">
            <p className="section-sub">Talented professionals united by a passion for technology and your success.</p>
          </div>
        </div>
        <div className="row g-4">
          {team.map((m,i) => (
            <div key={i} className="col-lg-3 col-md-6">
              <div className="warm-card">
                <div style={{ overflow:'hidden', height:300 }}>
                  <img src={m.img} alt={m.name} className="warm-card-img" style={{ height:300 }} />
                </div>
                <div style={{ padding:'22px 22px 26px' }}>
                  <h5 style={{ fontFamily:'var(--font-disp)', fontSize:'1.15rem', fontWeight:400, color:'var(--cream2)', marginBottom:4 }}>{m.name}</h5>
                  <div style={{ color:'var(--tan)', fontSize:'0.72rem', letterSpacing:'0.15em', textTransform:'uppercase', marginBottom:6 }}>{m.role}</div>
                  <div style={{ color:'var(--muted)', fontSize:'0.8rem' }}>{m.exp} Experience</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <CTABanner />
  </main>
);

export default About;
